import React, { useEffect } from "react";
import "./Privacy.css";

const privacyData = [
  {
    title: "Information Collection",
    content:
      "We collect personal information such as name, email, and usage data when you interact with MZR Software services.",
  },
  {
    title: "Use of Information",
    content:
      "Collected data is used to improve services, provide support, and communicate important updates to users.",
  },
  {
    title: "Cookies & Tracking",
    content:
      "We may use cookies and similar technologies to enhance user experience and analyze website traffic.",
  },
  {
    title: "Data Sharing",
    content:
      "MZR Software does not sell or share personal information with third parties without user consent, except as required by law.",
  },
  {
    title: "Data Security",
    content:
      "We implement appropriate technical and organizational measures to protect personal data from unauthorized access, alteration, or loss.",
  },
  {
    title: "User Rights",
    content:
      "Users may access, correct, or request deletion of their personal information in compliance with applicable privacy laws.",
  },
  {
    title: "Third-Party Services",
    content:
      "Some services may integrate third-party tools or platforms. Their privacy policies may apply when using those services.",
  },
  {
    title: "Policy Updates",
    content:
      "Privacy Policy may be updated periodically. Updated versions will be published on our website and are effective immediately.",
  },
];

function Privacy() {
  useEffect(() => {
    const cards = document.querySelectorAll(".small-term-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 },
    );

    cards.forEach((card) => observer.observe(card));
  }, []);

  return (
    <div className="privacy-page">
      <section className="services-section">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">
              Privacy <span className="highlight">Policy</span>
            </h2>
            <p className="section-subtitle">
              Please review how MZR Software collects, uses, and protects your
              data.
            </p>
          </div>

          <div className="row">
            {privacyData.map((item, index) => (
              <div
                key={index}
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
              >
                <div className="small-term-card">
                  <h6>
                    {index + 1}. {item.title}
                  </h6>
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
